import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { CardVerificationApiService } from './services/card-verification-api.service';
import { IdentityVerificationApiService } from './services/identity-verification-api.service';
import { VerificationProfileApiService } from './services/verification-profile-api.service';
import { CardVerificationEffects } from './state/effects/card';
import { IdentityVerificationEffects } from './state/effects/identity';
import { SummaryVerificationEffects } from './state/effects/summary';
import { CardVerificationFacade } from './state/facades/card';
import { IdentityVerificationFacade } from './state/facades/identity';
import { SummaryVerificationFacade } from './state/facades/summary';
import { reducers } from './state/reducers';

export const verificationProviders = [
  provideState('verification', reducers),
  provideEffects(
    IdentityVerificationEffects,
    SummaryVerificationEffects,
    CardVerificationEffects,
  ),
  IdentityVerificationApiService,
  IdentityVerificationFacade,
  VerificationProfileApiService,
  SummaryVerificationFacade,
  CardVerificationApiService,
  CardVerificationFacade,
];
